export const productTypesModel = [
  "",
  "Product",
  "Accessory",
  "Marketing Product",
  "Spare Part",
  "Services",
  "Other branded products",
];
